import React from "react";
import { Table, Tooltip } from "antd";
const { Column } = Table;

const data = [
  {
    key: "1",
    Beds: "",
    Units: 2,
    Rented: 1,
    Available: 1,
    VacantUnrented: 1,
    AvgDaysVacant: "0.00",
    MoveIns: 0,
  },
  {
    key: "2",
    Beds: "",
    Units: 2,
    Rented: 1,
    Available: 1,
    VacantUnrented: 1,
    AvgDaysVacant: "",
    MoveIns: 0,
  },
];

const AvailableToolTip = (
  <div className="dashboardTooltip">
    <h4>Available</h4>
    <p>
      Available units include available vacant units plus units occupied by
      tenants who show a future move-out date.
    </p>
  </div>
);
const PortfolioSummary = () => {
  return (
    <div className="PortfolioSummary">
      <Table dataSource={data} pagination={false}>
        <Column title="Beds" dataIndex="Beds" key="Beds" />
        <Column title="Units" dataIndex="Units" key="Units" />
        <Column title="Rented" dataIndex="Rented" key="Rented" />
        <Column
          title={
            <div>
              Available{" "}
              <Tooltip
                placement="top"
                title={AvailableToolTip}
                trigger={["click"]}
                color={["#fff"]}
              >
                <i className="fa-sharp fa-solid fa-circle-question"></i>
              </Tooltip>
            </div>
          }
          dataIndex="Available"
          key="Available"
        />
        <Column
          title="VacantUnrented"
          dataIndex="VacantUnrented"
          key="VacantUnrented"
        />
        <Column
          title="AvgDaysVacant"
          dataIndex="AvgDaysVacant"
          key="AvgDaysVacant"
        />
        <Column title="MoveIns" dataIndex="MoveIns" key="MoveIns" />
      </Table>
    </div>
  );
};

export default PortfolioSummary;
